import { getHidratationKey } from '@portal-internet/core';
import clsx from 'clsx';
import InnerHTML from 'dangerously-set-html-content';
import __isEmpty from 'lodash/isEmpty';
import styles from './text.module.scss';

export default function Text(props) {
    const { text, className, estil, tag } = props;
    const hidratationKey = getHidratationKey(text);

    const stylesText = clsx({
        [styles[estil]]: !__isEmpty(estil),
        [className]: !__isEmpty(className)
    });
    const CustomTag = `${tag}`;

    if (__isEmpty(text)) return <></>;

    if (tag === 'div') {
        return <InnerHTML key={hidratationKey} className={stylesText} html={text} />;
    } else {
        return <CustomTag key={hidratationKey} className={stylesText} dangerouslySetInnerHTML={{ __html: text }}></CustomTag>;
    }
}

Text.defaultProps = {
    text: '',
    tag: 'div',
    className: null,
    estil: null
};
